import { getLegacyBoilerOTState } from 'console/shared/content/device/heating-circuits/legacy/boiler';
import { useMemo } from 'react';
import { createSelector } from '@reduxjs/toolkit';
export const useLegacyOpenThermState = (id, device_state) => {
    const { last_boiler_state, otzones_last } = device_state;
    const open_therm_state = useMemo(() => {
        const ot_state = getLegacyBoilerOTState(id, last_boiler_state, otzones_last);
        if (ot_state) {
            return ot_state;
        }
        return {};
    }, [last_boiler_state?.ot, otzones_last?.[id - 1]]);
    return open_therm_state;
};
export const getLegacyOpenThermState = createSelector((id) => id, //идентификатор АЦШ
(id, device_state) => device_state.last_boiler_state, (id, device_state) => device_state.otzones_last, (id, last_boiler_state, ot_zones_last) => {
    const ot_state = getLegacyBoilerOTState(id, last_boiler_state, ot_zones_last);
    if (ot_state) {
        return ot_state;
    }
    return {};
});
